import React from 'react'
import classNames from 'classnames'
import { BasicPageContext, useEvolvedContext } from '../../context'
import style from './index.module.scss'

interface UtilityBox {
  className?: string
}

const UtilityBox: React.FC<UtilityBox> = ({
  children,
  className,
}): JSX.Element => {
  const isEvolved = useEvolvedContext()

  return (
    <BasicPageContext.Consumer>
      {isBasicPage =>
        !isBasicPage && (
          <div
            className={style.UtilityBoxContainer}
            data-test-id="utility-panel"
          >
            <div
              className={classNames(
                style.UtilityBox,
                { [style.evolved]: isEvolved },
                className
              )}
            >
              {children}
            </div>
          </div>
        )
      }
    </BasicPageContext.Consumer>
  )
}

export default UtilityBox
